import { IMAGES } from "../content/site";

export const Logo = ({ className = "h-10 w-auto" }) => {
  if (IMAGES.logoUrl) {
    return (
      <img
        src={IMAGES.logoUrl}
        alt={IMAGES.logoAlt || "TJ's Light Foundation logo"}
        className={`${className} object-contain`}
      />
    );
  }
  return (
    <svg
      viewBox="0 0 40 40"
      className={className}
      role="img"
      aria-label="TJ's Light Foundation logo — a rising sun over a horizon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20.5" r="6.5" fill="#1BBEC3" />
      <path d="M5 27 H35" stroke="#0A2547" strokeWidth="2.5" strokeLinecap="round" />
      <path
        d="M20 5.5 V10 M8.5 10.5 L11.5 13.5 M31.5 10.5 L28.5 13.5"
        stroke="#1BBEC3"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path d="M7 27 C13 31 27 31 33 27" stroke="#8B3FDF" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
